import { createFileRoute } from '@tanstack/react-router';
import { NotFound } from '../../catalogue/CataloguePage.js';

/** The bare `/catalogue`: there is no table without a type. */
export const Route = createFileRoute('/catalogue/')({ component: NotFound });
